module.exports = __webpack_public_path__ + "static/media/lucionLogo.1cd615f3.png";